
import Vue from "vue";

export default Vue.extend({
  name: "image-size",
  props: {
    base: {
      type: String,
      required: true,
    },
    side: {
      type: Number,
      required: false,
    },
  },
})
